<template>
  <div>
<!--    <button  v-if="!isFullscreen" @click="enterFullscreen">进入全屏</button>-->
<!--    <button  v-if="!isFullscreen" @click="update">刷新</button>-->
<!--    <button v-else @click="exitFullscreen">退出全屏</button>-->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="enterFullscreen"
          >
            全屏
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import screen from 'screenfull';

export default {
  inject:['reload'],
  data() {
    return {
      dialog:true,
      isFullscreen: false // 是否处于全屏模式
    };
  },
  methods: {
    enterFullscreen() {
      if (screen.isEnabled) { // 检查浏览器是否支持全屏模式
        screen.request(); // 进入全屏模式
        this.isFullscreen = true; // 更新状态
        this.dialog = false;
      }
    },
    exitFullscreen() {
      if (screen.isEnabled) { // 检查浏览器是否支持全屏模式
        screen.exit(); // 退出全屏模式
        this.isFullscreen = false; // 更新状态
      }
    },
    update(){
      this.reload()
    }
  },
  mounted() {
    // 监听全屏状态变化事件
    screen.on('change', () => {
      this.isFullscreen = screen.isFullscreen
    });
  },
  created() {
    screen.request(); // 进入全屏模式
    console.log("213")
  },
  beforeDestroy() {
    // 在组件销毁前移除全屏状态变化事件的监听器
    screen.off('change')
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/components/screenfull/index.vue